module.exports = __webpack_public_path__ + "static/top_img@2x-da29d44947364e0d2d392f30ffffc58e.png";